import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const PublicRoute = ({ children }) => {
  const token = Cookies.get("auth-token");

  return token ? <Navigate to="/dashboard" /> : children;
};
export default PublicRoute;
